/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState, useEffect, useRef } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  LinearProgress,
  InputBase,
} from "@material-ui/core";

import FileCopyIcon from "@mui/icons-material/FileCopy";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import SearchIcon from "@mui/icons-material/Search";
import GetAppIcon from "@mui/icons-material/GetApp";

import PrintButton from "components/_refactor/button/print";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import OccurencesDialog from "components/Dialogs/OccurencesDialog";
import IconButtonLoader from "components/Buttons/IconButtonLoader";
import ImagePlaceholder from "components/Image/ImagePlaceholder";
import UtilsFncs from "utils/UtilsFncs";
import Api from "lib/api/httpRequestHelper";
import useLogs from "hooks/logs";
import componentStyles from "assets/theme/views/index";
import componentStylesNotification from "assets/theme/components/dropdowns/notifications-dropdown.js";
import componentNavbarStyles from "assets/theme/components/navbars/admin-navbar.js";
import {
  sortableField,
  columnNumberField,
  columnPriceField,
  columnBooleanField,
  columnTextField,
} from "utils/tables-utils";

import { utils, writeFileXLSX } from "xlsx";
import { IsMobile, IsMobile900 } from "utils/is-mobile";

const useStyles = makeStyles(componentStyles);
const useNavbarStyles = makeStyles(componentNavbarStyles);
const useStylesNotification = makeStyles(componentStylesNotification);

const exportIconStyle = {
  width: 25,
  height: 25,
  marginLeft: 15,
};

const columnModel = (
  truncarChaveNF,
  urlConsultaSefaz,
  classes,
  fetchOccurencesData,
  downloadXMLFile,
  downloadPDFFile
) => [
  columnNumberField(
    {
      dataField: "Numero",
      text: "Número",
    },
    true
  ),
  columnTextField(
    {
      dataField: "DataEmissaoFormat",
      text: "Data Emissão",
    },
    true
  ),
  sortableField({
    dataField: "StatusNf",
    text: "Status",
    align: "center",
  }),
  columnPriceField(
    {
      dataField: "ValorLiquido",
      text: "Valor Liquido",
    },
    true
  ),
  columnBooleanField(
    {
      dataField: "Entregue",
      text: "Entregue",
    },
    true
  ),
  columnTextField(
    {
      dataField: "DataPrevisaoEntregaFormat",
      text: "Data Previsão Entrega",
    },
    true
  ),
  columnNumberField(
    {
      dataField: "NumeroProposta",
      text: "Nr. Proposta",
    },
    true
  ),
  columnNumberField(
    {
      dataField: "NumeroPedido",
      text: "Nr. Pedido",
    },
    true
  ),
  sortableField({
    dataField: "Marca",
    text: "Marca",
    align: "center",
  }),
  columnTextField(
    {
      dataField: "CCLoja",
      text: "CC Loja",
      align: "center",
      headerAlign: "center",
    },
    false
  ),
  sortableField({
    dataField: "NomeCondicaoPgto",
    text: "Condição Pagamento",
    align: "center",
  }),
  {
    dataField: "ChaveNf",
    text: "Chave da NF",
    sort: false,
    headerAlign: "center",
    align: "center",
    formatter: truncarChaveNF,
  },
  {
    dataField: "verOcorrencias",
    isDummyField: true,
    text: "Rastreio",
    headerAlign: "center",
    align: "center",
    sort: false,
    formatter: (cell, row) =>
      row.ChaveNf !== null &&
      row.ChaveNf > "" &&
      (row?.DataPrevisaoEntregaFormat !== "" ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconButtonLoader
            title="Ver Ocorrências de Entrega da Nota"
            className={classes.margin}
            size="small"
            onClick={() => fetchOccurencesData(row)}
            icon={<LocalShippingIcon />}
          />
        </div>
      ) : (
        <>
          {row?.NumeroProposta ? (
            <Tooltip title="Ver Ocorrências de Entrega da Nota" size="medium">
              <a
                style={{ color: "#525F7F" }}
                target="_blank"
                rel="noreferrer"
                href={row?.LinkRastreio}
              >
                <LocalShippingIcon
                  style={{ width: "1.6rem", height: "1.6rem" }}
                />
              </a>
            </Tooltip>
          ) : null}
        </>
      )),
    csvExport: false,
  },
  {
    dataField: "consulta",
    text: "Consulta Sefaz",
    headerAlign: "center",
    align: "center",
    isDummyField: true,
    formatter: urlConsultaSefaz,
    csvExport: false,
  },
  {
    dataField: "XmlNoS3",
    text: "XML",
    headerAlign: "center",
    align: "center",
    isDummyField: true,
    formatter: downloadXMLFile,
    csvExport: false,
  },
  {
    dataField: "PdfNoS3",
    text: "PDF",
    headerAlign: "center",
    align: "center",
    isDummyField: true,
    formatter: downloadPDFFile,
    csvExport: false,
  },
];

const fotoProdutoItem = (cell, row) => {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <ImagePlaceholder
        alt="Imagem do item do pedido"
        src={row.UrlFoto}
        width={64}
        widthOnError={40}
        imagePreviewTitle={`Produto ${row.IdProduto}`}
      />
    </div>
  );
};

const modelTableItemDetail = [
  {
    dataField: "UrlFoto",
    text: "Imagem",
    headerAlign: "center",
    align: "center",
    sort: false,
    formatter: fotoProdutoItem,
    csvExport: false,
  },
  sortableField({
    dataField: "Sequencial",
    text: "Sequencial Item",
    align: "center",
  }),
  sortableField({
    dataField: "SituacaoItemPedido",
    text: "Situação Item Pedido",
    align: "center",
  }),
  sortableField({
    dataField: "LinhaProduto",
    text: "Linha Produto",
  }),
  sortableField({
    dataField: "ColecaoProduto",
    text: "Coleção Produto",
  }),
  sortableField({
    dataField: "IdProduto",
    text: "Id Produto",
    align: "center",
  }),
  sortableField({
    dataField: "DescricaoProduto",
    text: "Descrição Produto",
  }),
  sortableField({
    dataField: "CodCorProduto",
    text: "Cod Cor Produto",
    align: "center",
  }),
  sortableField({
    dataField: "TamanhoProduto",
    text: "Tamanho Produto",
  }),
  columnNumberField(
    {
      dataField: "NumeroOd",
      text: "OD",
    },
    true
  ),
  columnNumberField(
    {
      dataField: "QtdFaturada",
      text: "Qtd Faturada",
      align: "right",
    },
    true
  ),
  columnNumberField(
    {
      dataField: "QtdDevolvida",
      text: "Qtd Devolvida",
      align: "right",
    },
    true
  ),
  columnPriceField(
    {
      dataField: "PrecoUnitario",
      text: "Preço Unitário",
    },
    true
  ),
  columnPriceField(
    {
      dataField: "ValorFinalItem",
      text: "Valor Liquido",
    },
    true
  ),
  sortableField({
    dataField: "NomeProduto",
    text: "Nome Produto",
  }),
];

const TableStoreNotasFiscais = ({ dataTable, labelDias }) => {
  const classes = {
    ...useStyles(),
    ...useNavbarStyles(),
    ...useStylesNotification(),
  };
  const snackbar = useSnackbar();
  const { setLocalStorageActions } = useLogs();

  const searchRef = useRef(null);
  const searchInputRef = useRef(null);
  const [inputRef, setInputRef] = useState(false);

  const [ocorrenciasNF, setOcorrenciasNF] = useState(null);
  const { setLocalStorageApiProblem } = useLogs();

  const [searchValue, setSearchValue] = useState("");
  const [fullDataTable, setFullDataTable] = useState([]);
  const [searchItemsList, setSearchItemsList] = useState(null);
  const [searchingItems, setSearchingItems] = useState(false);

  const [expandedRows, setExpandedRows] = useState([]);
  const [pageConfig, setPageConfig] = useState({
    page: 1,
    pageSize: 25,
  });

  const isMobile = IsMobile();
  const isMobile900 = IsMobile900();

  const getFileInvoice = async (tipo, chave) => {
    return await Api.get(tipo, "invoice", "?chaveNf=" + chave, false)
      .then((value) => {
        const url =
          "data:application/octet-stream;base64," + value.Result.FileBase64;
        const downloadLink = document.createElement("a");
        downloadLink.href = url;
        downloadLink.target = "_blank";
        downloadLink.download = chave + "." + tipo;
        downloadLink.click();
      })
      .catch((error) => {
        console.log(error);
        setLocalStorageApiProblem({
          idMenuAccess: "143",
          screen: "Consulta de Notas Fiscais",
          problem: `Erro na chamada do endpoint chaveNf - ${error}`,
        });
      });
  };

  const urlConsultaSefaz = useCallback(
    (cell, row) => {
      return (
        <div>
          {row.ChaveNf !== null && row.ChaveNf > "" ? (
            <IconButton
              title="Consultar Sefaz"
              className={classes.margin}
              size="small"
              href={
                "https://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=resumo&nfe=" +
                row.ChaveNf
              }
              target="_blank"
              onClick={() => {
                setLocalStorageActions({
                  nomeTela: "Lojista 360s",
                  idMenu: "10",
                  acao: "Clicou em Consultar Sefaz aba Notas Fiscais",
                });
              }}
            >
              <FindInPageIcon fontSize="large" />
            </IconButton>
          ) : (
            ""
          )}
        </div>
      );
    },
    [classes.margin]
  );

  const truncarChaveNF = React.useCallback(
    (cell, row) => {
      return row.ChaveNf !== null && row.ChaveNf > "" ? (
        <div>
          <IconButtonLoader
            title="Copiar Chave NF"
            className={classes.margin}
            size="small"
            onClick={() => {
              UtilsFncs.CopyToClipboard(row.ChaveNf);
              setLocalStorageActions({
                nomeTela: "Lojista 360s",
                idMenu: "10",
                acao: "Clicou em Copiar Chave NF aba Notas Fiscais",
              });
            }}
            icon={<FileCopyIcon fontSize="large" />}
          />
        </div>
      ) : null;
    },
    [classes.margin]
  );

  const downloadXMLFile = React.useCallback(
    (cell, row) => {
      return row.XmlNoS3 ? (
        <div>
          <IconButtonLoader
            title="Download XML"
            size="small"
            onClick={(e) => {
              getFileInvoice("xml", row.ChaveNf, e);
              setLocalStorageActions({
                nomeTela: "Lojista 360s",
                idMenu: "10",
                acao: "Clicou em Download XML aba Notas Fiscais",
              });
            }}
            icon={<GetAppIcon id={"downXML" + row.ChaveNf} fontSize="large" />}
          />
        </div>
      ) : null;
    },
    [classes.margin]
  );

  const downloadPDFFile = React.useCallback(
    (cell, row) => {
      return row.PdfNoS3 ? (
        <div>
          <IconButtonLoader
            title="Download PDF"
            size="small"
            onClick={(e) => {
              getFileInvoice("pdf", row.ChaveNf, e);
              setLocalStorageActions({
                nomeTela: "Lojista 360s",
                idMenu: "10",
                acao: "Clicou em Download PDF aba Notas Fiscais",
              });
            }}
            icon={<GetAppIcon id={"downPDF" + row.ChaveNf} fontSize="large" />}
          />
        </div>
      ) : null;
    },
    [classes.margin]
  );

  const fetchOccurencesData = useCallback(
    async (row) => {
      setLocalStorageActions({
        nomeTela: "Lojista 360s",
        idMenu: "10",
        acao: "Clicou em Ver Ocorrências de Entrega da Nota aba Notas Fiscais",
      });
      await Api.get(
        "tracking-occurrences",
        "sellinorder",
        "?chaveNF=" + row.ChaveNf,
        true
      )
        .then((value) => {
          if (
            value?.ErrorMessage ===
            "HTTPERRO 422 Não foi possível encontrar ocorrências de entrega. Verifique os parâmetros informados."
          ) {
            snackbar.showMessage(
              "Não foi possível encontrar ocorrências de entrega para essa nota.",
              {
                severity: "info",
              }
            );
          } else if (!value || value.Result?.Ocorrencias?.length === 0) {
            snackbar.showMessage(
              "Não foram encontradas ocorrências de entrega para essa nota.",
              {
                severity: "info",
              }
            );
          } else {
            setOcorrenciasNF({ ...row, ...value.Result });
          }
        })
        .catch((error) => {
          snackbar.showMessage(error, {
            severity: "error",
          });
          console.log(error);
          setLocalStorageApiProblem({
            idMenuAccess: "143",
            screen: "Consulta de Notas Fiscais",
            problem: `Erro na chamada do endpoint tracking-occurrences - ${error}`,
          });
        });
    },
    [snackbar]
  );

  function handleDownloadXML() {
    const data =
      searchItemsList?.length !== 0 && searchItemsList !== null
        ? searchItemsList
        : fullDataTable;

    const receipt = data.reduce((acc, item) => {
      const sellInItems = [...(item?.ItensSellinNF || [])];
      delete item?.ItensSellinNF;
      return [...acc, item, ...sellInItems];
    }, []);

    const wb = utils.book_new();
    utils.book_append_sheet(wb, utils.json_to_sheet(receipt), "NFs");
    writeFileXLSX(wb, "NFs.xlsx");
  }

  const exportCmp =
    searchItemsList?.length !== 0 && searchItemsList !== null ? (
      <>
        <span>
          <Tooltip title="Exportar tudo">
            <IconButtonLoader
              onClick={() => handleDownloadXML()}
              icon={
                <img
                  src="https://img.icons8.com/material-outlined/72/000000/xls-export.png"
                  alt="ícone clicável para exportar a tabela no formato Excel"
                  style={exportIconStyle}
                />
              }
              size="small"
            />
          </Tooltip>
        </span>
      </>
    ) : (
      <>
        {fullDataTable?.length !== 0 ? (
          <>
            <span>
              <Tooltip title="Exportar tudo">
                <IconButtonLoader
                  onClick={() => handleDownloadXML()}
                  icon={
                    <img
                      src="https://img.icons8.com/material-outlined/72/000000/xls-export.png"
                      alt="ícone clicável para exportar a tabela no formato Excel"
                      style={exportIconStyle}
                    />
                  }
                  size="small"
                />
              </Tooltip>
            </span>
          </>
        ) : null}
      </>
    );

  const handleInputClick = () => {
    setInputRef(true);
  };

  const handleClick = () => {
    if (searchValue !== "") {
      setSearchingItems(true);
      const listItens = [];
      fullDataTable?.map((item) => {
        if (
          item?.GrupoEconomico?.includes(searchValue) ||
          item?.RazaoSocial?.includes(searchValue?.toUpperCase()) ||
          item?.Apelido?.includes(searchValue?.toUpperCase()) ||
          item?.CnpjLojista?.includes(searchValue) ||
          item?.Numero?.toString()?.includes(searchValue?.toString()) ||
          item?.NumeroNf?.toString()?.includes(searchValue?.toString()) ||
          item?.DataEmissaoFormat?.includes(searchValue) ||
          item?.StatusNf?.includes(searchValue) ||
          item?.ValorLiquidoFormat?.includes(searchValue) ||
          item?.EntregueFormat?.includes(searchValue) ||
          item?.DataPrevisaoEntrega?.includes(searchValue) ||
          item?.NumeroProposta?.toString()?.includes(searchValue) ||
          item?.NumeroPedido?.toString()?.includes(searchValue?.toString()) ||
          item?.Marca?.includes(searchValue) ||
          item?.NomeCondicaoPgto?.includes(searchValue)
        ) {
          listItens.push(item);
        }
      });
      setSearchItemsList(listItens);
      setTimeout(() => {
        setSearchingItems(false);
      }, 500);
      setInputRef(false);
    }
  };

  const handleValueChange = useCallback((e) => {
    if (e.target.value === "") {
      setSearchItemsList(null);
    }
    setSearchValue(e.target.value);
    searchInputRef.current.focus();
  }, []);

  const expandRow = {
    renderer: (row) =>
      row?.ItensSellinNF?.length !== 0 ? (
        <Grid item xs={12}>
          <ToolkitProvider
            data={row?.ItensSellinNF || []}
            keyField={"IdProduto"}
            columns={modelTableItemDetail}
          >
            {(props) => (
              <PerfectScrollbar>
                <BootstrapTable
                  {...props.baseProps}
                  bootstrap4={true}
                  bordered={false}
                  condensed={true}
                  striped={true}
                  hover={true}
                  style={{ overflow: "auto!important" }}
                />
              </PerfectScrollbar>
            )}
          </ToolkitProvider>
        </Grid>
      ) : (
        <Grid
          item
          xs={6}
          style={{
            display: "flex",
            justifyContent: isMobile900 ? "flex-start" : "center",
            flexDirection: isMobile ? "column" : "row",
            marginBottom: "-1rem",
          }}
        >
          <p
            style={{
              color: "#DF767D",
              fontWeight: "bold",
              fontSize: "0.8rem",
              marginBottom: isMobile && "-0.2rem",
            }}
          >
            Itens indisponíveis para consulta no momento.
          </p>
          <p
            style={{
              color: "#DF767D",
              fontWeight: "bold",
              fontSize: "0.8rem",
            }}
          >
            Tente novamente mais tarde.
          </p>
        </Grid>
      ),
    expanded: expandedRows,
    onExpand: (row, isExpanded, rowIndex) => {
      if (isExpanded) {
        setExpandedRows((indexes) => [...indexes, row.Numero]);
      } else {
        setExpandedRows((indexes) => indexes.filter((x) => x !== row.Numero));
      }
    },

    showExpandColumn: true,
    expandHeaderColumnRenderer: () => (
      <div
        onClick={(e) => {
          e.stopPropagation();
          if (expandedRows?.length > 0) {
            setExpandedRows([]);
          } else {
            setExpandedRows(
              dataTable
                .slice(pageConfig.page - 1, pageConfig.pageSize)
                .map((row) => row.Numero)
            );
          }
        }}
      >
        {expandedRows?.length > 0 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </div>
    ),
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <ExpandLessIcon />;
      }
      return <ExpandMoreIcon />;
    },
  };

  useEffect(() => {
    if (searchItemsList?.length === 0) {
      setTimeout(() => {
        setSearchItemsList(null);
      }, 2500);
    }
  }, [searchItemsList]);

  useEffect(() => {
    setFullDataTable(dataTable);
  }, [dataTable]);

  return (
    <>
      <Grid item xs={12}>
        {searchingItems ? (
          <div style={{ marginTop: "1rem" }}>
            <span>Buscando dados..</span>
            <LinearProgress />
          </div>
        ) : (
          <ToolkitTable
            searched={Boolean(dataTable)}
            keyField="Numero"
            dataTable={searchItemsList ? searchItemsList : fullDataTable}
            columnModel={columnModel(
              truncarChaveNF,
              urlConsultaSefaz,
              classes,
              fetchOccurencesData,
              downloadXMLFile,
              downloadPDFFile
            )}
            pagination={{
              options: [25, 50, 100],
              defaultOption: 25,
              totalSize: searchItemsList
                ? searchItemsList?.length
                : fullDataTable?.length,
              showTotal: true,
              onPageChange: (page, pageSize) =>
                setPageConfig({ page, pageSize }),
            }}
            notFoundTitle="Sua pesquisa não encontrou Notas Fiscais correspondentes."
            bootstrapTableProps={{ expandRow }}
            CustomHeader={({ componentRefProps, selectRefProps }) => (
              <Grid
                container
                className="pl-4"
                style={{ height: 60, padding: "0 24px 12px" }}
              >
                <Grid
                  item
                  xs={isMobile ? 12 : 6}
                  style={{
                    display: "flex",
                    alignItems: isMobile ? "flex-start" : "center",
                    marginBottom: isMobile ? "1rem" : 0,
                    flexDirection: isMobile ? "column" : "row",
                  }}
                >
                  <Box
                    component={Typography}
                    variant="h3"
                    marginBottom="0!important"
                  >
                    <Box component="span">
                      {typeof labelDias === "string"
                        ? `Notas Fiscais entre ${labelDias}`
                        : `Notas Fiscais nos últimos ${labelDias} dias`}
                    </Box>
                  </Box>
                  <Box
                    display="flex"
                    ref={searchRef}
                    alignItems="center"
                    width="auto"
                    component={Grid}
                    className={classes.searchBox}
                    style={{ marginLeft: isMobile ? 0 : "1rem" }}
                  >
                    <Tooltip title={"Pesquisar"}>
                      <SearchIcon
                        className={classes.searchIcon}
                        onClick={handleClick}
                        style={{ cursor: "pointer" }}
                        fontSize="large"
                      />
                    </Tooltip>
                    <InputBase
                      inputRef={searchInputRef}
                      placeholder="Faça a sua busca"
                      classes={{
                        input: classes.searchInput,
                      }}
                      onClick={handleInputClick}
                      value={searchValue}
                      onChange={handleValueChange}
                      autoComplete="off"
                      name="search"
                      autoFocus={inputRef}
                      inputProps={{
                        autoFocus: inputRef,
                      }}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={isMobile ? 12 : 6}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: isMobile ? "flex-start" : "flex-end",
                    padding: 0,
                    marginBottom: "0.5rem!important",
                    marginTop: isMobile && "0.5rem",
                  }}
                >
                  <Box
                    justifyContent="flex-end"
                    alignItems="center"
                    display="flex"
                    flexWrap="wrap"
                    style={{
                      marginLeft: !isMobile && 15,
                      marginRight: 15,
                      cursor: "pointer",
                    }}
                  >
                    {exportCmp}
                  </Box>
                  <Box
                    justifyContent="flex-end"
                    alignItems="center"
                    display="flex"
                    flexWrap="wrap"
                    style={{
                      marginLeft: 15,
                      marginRight: 15,
                      cursor: "pointer",
                    }}
                  >
                    <PrintButton
                      selectRef={selectRefProps}
                      componentRef={componentRefProps}
                      dataTable={
                        searchItemsList ? searchItemsList : fullDataTable
                      }
                    />
                  </Box>
                </Grid>
              </Grid>
            )}
          />
        )}
      </Grid>
      {ocorrenciasNF ? (
        <OccurencesDialog
          data={ocorrenciasNF}
          handleClose={() => setOcorrenciasNF(null)}
          dialogTitle={`Ocorrências de Entrega da Nota ${ocorrenciasNF.Numero} - ${ocorrenciasNF.Serie}`}
        />
      ) : null}
    </>
  );
};

TableStoreNotasFiscais.propTypes = {
  dataTable: PropTypes.array,
  labelDias: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TableStoreNotasFiscais;
